// @ts-nocheck
// Browser-only Shopify script: Fabric.js, PDF.js, and theme custom elements are runtime globals.
document.addEventListener("DOMContentLoaded", () => {
  const state = {
    uploadedImage: null,
    originalArtwork: null,
    artworkPreview: null,
    finalPreviewDataUrl: "",
    editedDesignFile: null,
    designComplete: false,
    designerOpen: false,
    designerInitialized: false,
    hasUnsavedChanges: false,
    guidesEnabled: true,
    snappingEnabled: true,
    savedCanvasJSON: null,
    background_color: "Black Rectangle",
    font: "Anton",
    text_color: "Black",
    custom_text: "",
    decal_size: "2.5x8.3 - Rectangle",
    special_instructions: "",
    quantity: 1,
    lamination: "No Lamination",
    price: 9.95,
  };

  const FREE_SHIP_THRESHOLD = 25;
  const BASE_PRICE = 9.95;
  const MAX_EXPORT_DIMENSION = 6000;
  const FABRIC_CDN = "https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js";

  const BACKGROUND_COLORS = {
    Black: "#000000", White: "#ffffff", Red: "#ff0000", "Royal Blue": "#0000ff",
    "Sky Blue": "#00ccff", Magenta: "#ff00ff", Purple: "#9900cc", "Ruby Red": "#990000",
    Orange: "#ff6600", Green: "#00ff00", "Grass Green": "#009933", Pink: "#ff99cc", Yellow: "#ffff00",
  };
  const TEXT_COLORS = { ...BACKGROUND_COLORS };

  const FONT_FAMILY_MAP = Object.freeze({
    "Action Force": "ActionForce",
    "Another Danger": "AnotherDanger",
    Anton: "Anton",
    "Archivo Black": "Archivo Black",
    "3rd Rail": "Third_Rail",
    Arial: "Arial",
    Audiowide: "Audiowide",
    "Bad Script": "Bad Script",
    Bangers: "Bangers",
    "Black Ops One": "Black Ops One",
    "Bowlby One SC": "Bowlby One SC",
    "Bree Serif": "Bree Serif",
    Caveat: "Caveat",
    Cookie: "Cookie",
    Courgette: "Courgette",
    Facon: "Facon",
    Georgia: "Georgia",
    "Homemade Apple": "Homemade Apple",
    "Julius Sans One": "Julius Sans One",
    Lobster: "Lobster",
    "Luckiest Guy": "Luckiest Guy",
    "Mountains of Christmas": "Mountains of Christmas",
    Nosifer: "Nosifer",
    Pacifico: "Pacifico",
    "Permanent Marker": "Permanent Marker",
    Roboto: "Roboto",
    "Rock Salt": "Rock Salt",
    Sanchez: "Sanchez",
    "San Andreas": "SanAndreas",
    "Special Elite": "Special Elite",
    Staatliches: "Staatliches",
    "White on Black": "WhiteOnBlack",
    YellowTail: "Yellowtail",
  });
  const GOOGLE_FONT_VALUES = new Set([
    "Anton", "Archivo Black", "Audiowide", "Bad Script", "Bangers", "Black Ops One", "Bowlby One SC",
    "Bree Serif", "Caveat", "Cookie", "Courgette", "Homemade Apple", "Julius Sans One", "Lobster",
    "Luckiest Guy", "Mountains of Christmas", "Nosifer", "Pacifico", "Permanent Marker", "Roboto",
    "Rock Salt", "Sanchez", "Special Elite", "Staatliches", "YellowTail",
  ]);
  const SYSTEM_FONT_VALUES = new Set(["Arial", "Georgia"]);
  const FONT_LOAD_CACHE = new Map();
  const WARNED_FONT_FAILURES = new Set();
  const FONT_TEST_TEXT = "Bumper Sticker 0123456789";

  const PRICE_VARIANTS = {
    decal_size: [
      { value: "2.5x8.3 - Rectangle", price: 0 }, { value: "3x10 - Rectangle", price: 4 },
      { value: "3.5x11.25 - Rectangle", price: 6 }, { value: "4x13.3 - Rectangle", price: 8 },
      { value: "5x16.6 - Rectangle", price: 12 }, { value: "4x4 - Square", price: 1 },
      { value: "5x5 - Square", price: 3 }, { value: "6x6 - Square", price: 4 },
    ],
    quantity: [
      { value: "1", price: 0 }, { value: "2", price: 4 }, { value: "5", price: 12 },
      { value: "10", price: 22 }, { value: "25", price: 52 }, { value: "50", price: 102 }, { value: "100", price: 202 },
    ],
    lamination: [
      { value: "No Lamination", price: 0 },
      { value: "YES ADD LAM- Recommend if used on cars", price: 5 },
    ],
  };

  const ALLOWED_UPLOAD_EXT = ["jpg", "jpeg", "png", "webp", "svg", "pdf", "tiff", "tif", "ai", "eps"];
  const ALLOWED_UPLOAD_MIME = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/svg+xml", "image/tiff", "application/pdf", "application/postscript", "application/illustrator", "application/vnd.adobe.illustrator"];
  const NO_PREVIEW_EXT = ["ai", "eps"];

  const CBS_PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;
  const CBS_PCS_CART_LOADING_HTML = `<span class="cbs-pcs-cart-loading"><svg class="cbs-pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

  let fabricLoadingPromise = null;
  let googleFontStylesheetPromise = null;
  let lockedScrollY = 0;
  let messageTimer = null;

  function debounce(fn, delay) {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), delay); };
  }  const warnedMissingElements = new Set();

  function warnMissingElement(selector, feature) {
    if (warnedMissingElements.has(selector)) return;
    warnedMissingElements.add(selector);
    console.warn(`[Print Custom Bumper Stickers] Missing required element ${selector}; ${feature} is unavailable.`);
  }


  function validateFabricRuntime(runtime) {
    const major = Number.parseInt(String(runtime?.version || "").split(".")[0], 10);
    if (!runtime?.Canvas || major !== 5) {
      throw new Error(`Print Custom Bumper Stickers requires Fabric.js v5; found ${runtime?.version || "no compatible runtime"}.`);
    }
    return runtime;
  }

  function ensureFabric() {
    if (window.fabric) {
      try { return Promise.resolve(validateFabricRuntime(window.fabric)); }
      catch (error) { return Promise.reject(error); }
    }
    if (fabricLoadingPromise) return fabricLoadingPromise;
    fabricLoadingPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-cbs-fabric-loader]');
      const script = existing || document.createElement("script");
      const finish = () => {
        try { resolve(validateFabricRuntime(window.fabric)); }
        catch (error) { reject(error); }
      };
      script.addEventListener("load", finish, { once: true });
      script.addEventListener("error", () => reject(new Error("Could not load Fabric.js v5.3.1 for the design canvas.")), { once: true });
      if (!existing) {
        script.src = FABRIC_CDN;
        script.async = true;
        script.dataset.cbsFabricLoader = "true";
        document.head.appendChild(script);
      }
    });
    return fabricLoadingPromise;
  }

  function getFileExtension(file) {
    const parts = String(file?.name || "").split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }

  function isAllowedUpload(file) {
    const ext = getFileExtension(file);
    return Boolean(file && (ALLOWED_UPLOAD_EXT.includes(ext) || (file.type && ALLOWED_UPLOAD_MIME.includes(file.type))));
  }

  function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Error reading file"));
      reader.readAsDataURL(file);
    });
  }

  let pdfJsLoading = null;
  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfJsLoading) return pdfJsLoading;
    pdfJsLoading = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
      script.onload = () => {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
        resolve(window.pdfjsLib);
      };
      script.onerror = () => reject(new Error("Could not load PDF preview library"));
      document.head.appendChild(script);
    });
    return pdfJsLoading;
  }

  async function renderPdfFirstPagePreview(file) {
    const pdfjsLib = await loadPdfJs();
    const pdf = await pdfjsLib.getDocument({ data: await file.arrayBuffer() }).promise;
    const page = await pdf.getPage(1);
    const base = page.getViewport({ scale: 1 });
    const scale = Math.min(1200 / base.width, 1200 / base.height, 3);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.width = Math.ceil(viewport.width);
    canvas.height = Math.ceil(viewport.height);
    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
    return canvas.toDataURL("image/png");
  }

  async function buildUploadPreview(file) {
    const ext = getFileExtension(file);
    if (NO_PREVIEW_EXT.includes(ext)) return { src: null, placeholder: true };
    if (ext === "pdf" || file.type === "application/pdf") {
      try { return { src: await renderPdfFirstPagePreview(file), placeholder: false }; }
      catch (error) { console.warn("PDF preview failed:", error); return { src: null, placeholder: true }; }
    }
    if (file.type?.startsWith("image/") || ["jpg", "jpeg", "png", "webp", "svg", "tiff", "tif"].includes(ext)) {
      return { src: await readFileAsDataURL(file), placeholder: false };
    }
    return { src: null, placeholder: true };
  }

  function parseDecalSize(value = state.decal_size) {
    const raw = String(value || "");
    const match = raw.match(/^([\d.]+)x([\d.]+)\s*-\s*(Rectangle|Square)$/i);
    if (!match) return { width: 8.3, height: 2.5, shape: "Rectangle" };
    return {
      width: Number(match[2]),
      height: Number(match[1]),
      shape: match[3][0].toUpperCase() + match[3].slice(1).toLowerCase(),
    };
  }

  function shapeFrom(value) { return String(value).includes("Square") ? "Square" : "Rectangle"; }
  function colorNameFromBackground(value) { return String(value).replace(/\s+(Rectangle|Square)$/i, ""); }
  function backgroundHex(value = state.background_color) { return BACKGROUND_COLORS[colorNameFromBackground(value)] || "#000000"; }
  function fontFamilyForCanvas(value) {
    return FONT_FAMILY_MAP[value] || value || "Arial";
  }

  function normalizedFontFamily(value) {
    return String(value || "").replace(/["']/g, "").trim().toLowerCase();
  }

  function hasDeclaredFontFace(family) {
    if (!document.fonts || typeof document.fonts[Symbol.iterator] !== "function") return true;
    const expected = normalizedFontFamily(family);
    return Array.from(document.fonts).some((face) => normalizedFontFamily(face.family) === expected);
  }

  function waitForGoogleFontStylesheet() {
    if (googleFontStylesheetPromise) return googleFontStylesheetPromise;
    googleFontStylesheetPromise = new Promise((resolve, reject) => {
      const stylesheet = document.getElementById("cbs-designer-google-fonts");
      if (!stylesheet) {
        reject(new Error("The bumper-sticker Google Fonts stylesheet is missing."));
        return;
      }
      if (stylesheet.sheet) {
        resolve();
        return;
      }
      const timeout = window.setTimeout(() => reject(new Error("The Google Fonts stylesheet timed out.")), 8000);
      stylesheet.addEventListener("load", () => { window.clearTimeout(timeout); resolve(); }, { once: true });
      stylesheet.addEventListener("error", () => { window.clearTimeout(timeout); reject(new Error("The Google Fonts stylesheet could not load.")); }, { once: true });
    });
    return googleFontStylesheetPromise;
  }

  async function ensureCanvasFont(selectedValue, { warnUser = false } = {}) {
    const family = fontFamilyForCanvas(selectedValue);
    if (SYSTEM_FONT_VALUES.has(selectedValue) || !document.fonts) return family;
    const cacheKey = `${selectedValue}::${family}`;
    if (!FONT_LOAD_CACHE.has(cacheKey)) {
      FONT_LOAD_CACHE.set(cacheKey, (async () => {
        if (GOOGLE_FONT_VALUES.has(selectedValue)) await waitForGoogleFontStylesheet();
        await document.fonts.load(`16px "${family}"`, FONT_TEST_TEXT);
        await document.fonts.ready;
        if (!hasDeclaredFontFace(family) || !document.fonts.check(`16px "${family}"`, FONT_TEST_TEXT)) {
          throw new Error(`No loaded @font-face declaration matched "${family}".`);
        }
        return family;
      })().catch((error) => {
        if (!WARNED_FONT_FAILURES.has(selectedValue)) {
          WARNED_FONT_FAILURES.add(selectedValue);
          console.warn(`[BumperStickerDesigner] Font "${selectedValue}" (${family}) is unavailable; using Arial.`, error);
        }
        return "Arial";
      }));
    }
    const resolvedFamily = await FONT_LOAD_CACHE.get(cacheKey);
    if (warnUser && resolvedFamily === "Arial" && selectedValue !== "Arial") {
      showCanvasMessage(`The ${selectedValue} font is unavailable, so the preview uses Arial.`);
    }
    return resolvedFamily;
  }

  function fileFromDataURL(dataURL, filename) {
    const [header, body] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)?.[1] || "image/png";
    const binary = atob(body);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new File([bytes], filename, { type: mime });
  }

  function showCanvasMessage(message) {
    const el = document.getElementById("cbs-canvas-message");
    if (!el) return;
    clearTimeout(messageTimer);
    el.textContent = message;
    el.classList.add("is-visible");
    messageTimer = setTimeout(() => el.classList.remove("is-visible"), 4500);
  }

  function formatUploadFileName(name, maxBaseLen = 22) {
    if (!name) return "";
    const dot = name.lastIndexOf(".");
    const base = dot > 0 ? name.slice(0, dot) : name;
    const ext = dot > 0 ? name.slice(dot) : "";
    return base.length > maxBaseLen ? `${base.slice(0, maxBaseLen)}…${ext}` : name;
  }

  function setUploadPreview(src, usePlaceholder) {
    const thumb = document.getElementById("upload-preview-thumb");
    const placeholder = document.getElementById("upload-preview-placeholder");
    if (thumb) { thumb.src = src || ""; thumb.hidden = !src || usePlaceholder; }
    if (placeholder) placeholder.hidden = !usePlaceholder;
  }

  function setUploadUI(hasFile, fileName) {
    const uploadZone = document.querySelector("#designer-artwork-variant .cbs-pcs-upload-zone");
    const success = document.getElementById("upload-success-bar");
    const filename = document.getElementById("upload-filename");
    uploadZone?.classList.toggle("cbs-pcs-upload-zone--hidden", hasFile);
    if (success) { success.hidden = !hasFile; success.classList.toggle("cbs-pcs-upload-success--visible", hasFile); }
    if (filename) { filename.textContent = hasFile ? formatUploadFileName(fileName) : ""; filename.title = hasFile ? fileName : ""; }
    if (!hasFile) setUploadPreview(null, false);
  }

  function animatePriceChange(target, start, end, duration = 360) {
    const startTime = performance.now();
    const draw = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      target.textContent = (start + (end - start) * progress).toFixed(2);
      if (progress < 1) requestAnimationFrame(draw);
    };
    requestAnimationFrame(draw);
  }

  function priceOf(group, value) { return PRICE_VARIANTS[group]?.find((item) => item.value === value)?.price || 0; }

  function updateBuyBar(total) {
    const wrap = document.getElementById("cbs-pcs-shipping");
    const fill = document.getElementById("cbs-pcs-shipping-fill");
    const text = document.getElementById("cbs-pcs-shipping-text");
    if (!wrap || !fill) return;
    const remaining = FREE_SHIP_THRESHOLD - total;
    if (remaining <= 0) {
      wrap.classList.add("is-free");
      if (text) text.innerHTML = "You unlocked <strong>free shipping</strong>";
      fill.style.width = "100%";
    } else {
      wrap.classList.remove("is-free");
      if (text) text.innerHTML = `Add <strong id="cbs-pcs-shipping-amount">$${remaining.toFixed(2)}</strong> more for <strong>free shipping</strong>`;
      fill.style.width = `${Math.min(100, Math.round((total / FREE_SHIP_THRESHOLD) * 100))}%`;
    }
  }

  function recalcPrice() {
    const total = BASE_PRICE + priceOf("decal_size", state.decal_size) + priceOf("quantity", String(state.quantity)) + priceOf("lamination", state.lamination);
    const el = document.getElementById("cbs-pcs-final-price");
    if (!el) warnMissingElement("#cbs-pcs-final-price", "price display");
    if (el) {
      const previous = Number.parseFloat(el.textContent) || BASE_PRICE;
      if (previous !== total) animatePriceChange(el, previous, total);
      else el.textContent = total.toFixed(2);
    }
    state.price = total;
    updateBuyBar(total);
  }

  function updateDesignSummary() {
    const values = {
      "cbs-summary-size": state.decal_size,
      "cbs-summary-background": state.background_color,
      "cbs-summary-font": state.font,
      "cbs-summary-text-color": state.text_color,
    };
    Object.entries(values).forEach(([id, value]) => {
      const el = document.getElementById(id);
      if (el) el.textContent = value;
    });
    const status = document.getElementById("cbs-designer-size-status");
    if (status) status.textContent = state.decal_size.replace("x", "” × ").replace(" - ", "” ");
    const frame = document.getElementById("cbs-design-preview-frame");
    const size = parseDecalSize();
    if (frame) frame.style.setProperty("--cbs-preview-aspect", `${size.width} / ${size.height}`);
  }

  function syncSelectTriggerSwatch(dropdown, value) {
    dropdown?.querySelector(".cbs-pcs-select__trigger .cbs-pcs-select__swatch")?.setAttribute("data-bg-swatch", value);
  }

  function setDropdownValue(dropdown, value) {
    if (!dropdown) return;
    const option = [...dropdown.querySelectorAll("li[data-value]")].find((li) => li.dataset.value === value);
    if (!option) return;
    dropdown.querySelectorAll("li[data-value]").forEach((li) => li.classList.toggle("selected", li === option));
    const header = dropdown.querySelector(".selected-text");
    if (header) {
      header.textContent = value;
      if (dropdown.dataset.stateKey === "font") {
        [...header.classList].forEach((cls) => cls.startsWith("font-") && header.classList.remove(cls));
        [...option.classList].forEach((cls) => cls.startsWith("font-") && header.classList.add(cls));
      }
    }
    if (dropdown.dataset.stateKey === "background_color") syncSelectTriggerSwatch(dropdown, value);
  }

  function syncBackgroundToSize() {
    const next = `${colorNameFromBackground(state.background_color)} ${shapeFrom(state.decal_size)}`;
    if (next === state.background_color) return;
    state.background_color = next;
    setDropdownValue(document.getElementById("background-color-select"), next);
    designer.updateBackground();
  }

  function syncSizeToBackground() {
    const desiredShape = shapeFrom(state.background_color);
    if (shapeFrom(state.decal_size) === desiredShape) return;
    const firstMatch = [...document.querySelectorAll("#decal-size-grid [data-decal-size]")].find((button) => shapeFrom(button.dataset.decalSize) === desiredShape);
    if (!firstMatch) return;
    document.querySelectorAll("#decal-size-grid .sticker-variant").forEach((button) => button.classList.toggle("active", button === firstMatch));
    state.decal_size = firstMatch.dataset.decalSize;
    designer.resizeCanvas(true);
    recalcPrice();
  }

  function initDropdownDefaults() {
    document.querySelectorAll("#cbs-custom-fields .cbs-pcs-select").forEach((dropdown) => {
      const selected = dropdown.querySelector("li.selected") || dropdown.querySelector("li[data-value]");
      if (selected) setDropdownValue(dropdown, selected.dataset.value);
    });
  }

  function dropdownClickHandler(event) {
    const dropdown = event.target.closest(".cbs-pcs-select");
    if (!dropdown) {
      document.querySelectorAll("#cbs-custom-fields .dropdown-options").forEach((list) => {
        list.style.display = "none";
        list.closest(".cbs-pcs-select")?.classList.remove("is-open");
      });
      return;
    }
    const list = dropdown.querySelector(".dropdown-options");
    const trigger = dropdown.querySelector(".cbs-pcs-select__trigger");
    const option = event.target.closest("li[data-value]");
    document.querySelectorAll("#cbs-custom-fields .dropdown-options").forEach((other) => {
      if (other !== list) { other.style.display = "none"; other.closest(".cbs-pcs-select")?.classList.remove("is-open"); }
    });
    if (option) {
      const key = dropdown.dataset.stateKey;
      const value = option.dataset.value;
      setDropdownValue(dropdown, value);
      if (key) state[key] = value;
      list.style.display = "none";
      dropdown.classList.remove("is-open");
      trigger?.setAttribute("aria-expanded", "false");
      if (key === "background_color") { syncSizeToBackground(); designer.updateBackground(); }
      if (key === "font") designer.updateFont(value);
      updateDesignSummary();
      recalcPrice();
      return;
    }
    if (trigger && (event.target === trigger || trigger.contains(event.target))) {
      event.preventDefault();
      const open = list.style.display === "block";
      list.style.display = open ? "none" : "block";
      dropdown.classList.toggle("is-open", !open);
      trigger.setAttribute("aria-expanded", String(!open));
    }
  }

  class BumperStickerDesigner {
    constructor(options = {}) {
      this.options = options;
      this.fabric = null;
      this.canvas = null;
      this.artworkObject = null;
      this.textObject = null;
      this.guideObjects = [];
      this.snapObjects = [];
      this.snappingEnabled = state.snappingEnabled;
      this.guidesEnabled = state.guidesEnabled;
      this.initialized = false;
      this.controlsBound = false;
      this.resizeObserver = null;
      this.resizeHandler = debounce(() => this.resizeCanvas(true), 100);
      this.artworkLoadToken = 0;
      this.fontApplicationToken = 0;
      this.appliedFontFamily = "Arial";
      this.openingTrigger = document.getElementById(options.startButtonId || "cbs-start-design-btn");
      this.editingTrigger = document.getElementById(options.editButtonId || "cbs-edit-design-btn");
      this.designerModal = document.getElementById(options.modalId || "cbs-designer-tool");
      this.finishButton = document.getElementById(options.finishButtonId || "cbs-finish-editing");
      this.closeButton = document.getElementById(options.closeButtonId || "cbs-designer-close-btn");
      this.canvasElement = document.getElementById(options.canvasId || "cbs-sticker-canvas");
      this.canvasContainer = document.getElementById(options.canvasContainerId || "cbs-designer-canvas-container");
      this.previewImage = document.getElementById(options.previewImageId || "preview-image");
      this.emptyPreview = document.getElementById(options.emptyPreviewId || "cbs-design-empty");
      this.completedPreview = document.getElementById(options.completedPreviewId || "cbs-design-complete");
      this.loadingElement = document.getElementById("cbs-canvas-loading");
      this.closeConfirm = document.getElementById("cbs-close-confirm");
    }

    warnForMissingElements() {
      const required = [
        [this.openingTrigger, "#cbs-start-design-btn"],
        [this.designerModal, "#cbs-designer-tool"],
        [this.finishButton, "#cbs-finish-editing"],
        [this.closeButton, "#cbs-designer-close-btn"],
        [this.canvasElement, "#cbs-sticker-canvas"],
        [this.canvasContainer, "#cbs-designer-canvas-container"],
        [this.previewImage, "#preview-image"],
        [this.emptyPreview, "#cbs-design-empty"],
        [this.completedPreview, "#cbs-design-complete"],
      ];
      required.forEach(([element, selector]) => {
        if (!element) console.warn(`[BumperStickerDesigner] Missing required element ${selector}; its designer feature is unavailable.`);
      });
    }

    async init() {
      if (this.initialized) return this;
      this.warnForMissingElements();
      this.bindControlEvents();
      if (!this.canvasElement || !this.canvasContainer) {
        throw new Error("The bumper-sticker canvas markup is incomplete.");
      }
      this.fabric = await ensureFabric();
      this.appliedFontFamily = await ensureCanvasFont(state.font);
      this.initializeCanvas();
      this.initialized = Boolean(this.canvas);
      state.designerInitialized = this.initialized;
      this.updateFinishAvailability();
      return this;
    }

    initializeCanvas() {
      if (this.canvas || !this.canvasContainer || !this.canvasElement || !this.fabric?.Canvas) return;
      this.canvas = new this.fabric.Canvas(this.canvasElement.id, {
        width: Math.max(320, this.canvasContainer.clientWidth || 720),
        height: Math.max(180, this.canvasContainer.clientHeight || 420),
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
        uniformScaling: true,
        uniScaleKey: null,
        centeredScaling: false,
        backgroundColor: backgroundHex(),
      });
      this.canvas.uniformScaling = true;
      this.canvas.uniScaleKey = null;
      this.canvas.centeredScaling = false;
      this.fabric.Object.prototype.transparentCorners = false;
      this.fabric.Object.prototype.cornerStyle = "circle";
      this.fabric.Object.prototype.cornerColor = "#f0a028";
      this.fabric.Object.prototype.cornerStrokeColor = "#111114";
      this.fabric.Object.prototype.borderColor = "#f0a028";
      this.fabric.Object.prototype.padding = 2;
      this.bindCanvasEvents();
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.resizeHandler);
        this.resizeObserver.observe(this.canvasContainer);
      }
      window.addEventListener("resize", this.resizeHandler);
      this.resizeCanvas(false);
      this.updateBackground(false);
      this.drawGuides();
    }

    configureUniformTransformControls(object) {
      if (!object || object.cbsHelper) return object;
      object.set({
        lockUniScaling: true,
        centeredScaling: false,
        lockScalingFlip: true,
      });
      if (typeof object.setControlsVisibility === "function") {
        object.setControlsVisibility({
          ml: false,
          mr: false,
          mt: false,
          mb: false,
          tl: true,
          tr: true,
          bl: true,
          br: true,
          mtr: true,
        });
      }
      object.setCoords?.();
      return object;
    }

    bindControlEvents() {
      if (this.controlsBound) return;
      this.controlsBound = true;
      this.openingTrigger?.addEventListener("click", () => this.open());
      this.editingTrigger?.addEventListener("click", () => this.open());
      document.getElementById("cbs-remove-design-btn")?.addEventListener("click", () => this.removeDesign());
      this.finishButton?.addEventListener("click", () => this.finishEditing());
      this.closeButton?.addEventListener("click", () => this.requestClose());
      document.getElementById("cbs-cancel-close")?.addEventListener("click", () => {
        if (this.closeConfirm) this.closeConfirm.hidden = true;
        this.closeButton?.focus();
      });
      document.getElementById("cbs-confirm-close")?.addEventListener("click", () => this.close(true));
      document.getElementById("cbs-toggle-guides")?.addEventListener("change", (event) => this.setGuidesVisible(event.target.checked));
      document.getElementById("cbs-toggle-snapping")?.addEventListener("change", (event) => this.setSnappingEnabled(event.target.checked));
      document.querySelectorAll("[data-cbs-align]").forEach((button) => button.addEventListener("click", () => this.alignActive(button.dataset.cbsAlign)));
      document.getElementById("cbs-layer-up")?.addEventListener("click", () => this.moveLayer("up"));
      document.getElementById("cbs-layer-down")?.addEventListener("click", () => this.moveLayer("down"));
      document.getElementById("cbs-delete-selected")?.addEventListener("click", () => this.deleteSelected());
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape" || !state.designerOpen) return;
        event.preventDefault();
        if (this.closeConfirm && !this.closeConfirm.hidden) this.closeConfirm.hidden = true;
        else this.requestClose();
      });
    }

    bindCanvasEvents() {
      this.canvas.on("object:moving", (event) => this.snapObject(event.target));
      this.canvas.on("object:modified", () => { this.clearSnapLines(); this.markUnsaved(); });
      this.canvas.on("mouse:up", () => this.clearSnapLines());
      this.canvas.on("selection:created", () => this.updateToolAvailability());
      this.canvas.on("selection:updated", () => this.updateToolAvailability());
      this.canvas.on("selection:cleared", () => this.updateToolAvailability());
      this.canvas.on("object:added", (event) => {
        if (!event.target?.cbsHelper) {
          this.configureUniformTransformControls(event.target);
          this.bringHelpersToFront();
        }
        this.updateToolAvailability();
      });
      this.canvas.on("object:removed", () => this.updateToolAvailability());
      this.canvas.on("text:changed", (event) => {
        if (event.target !== this.textObject) return;
        const nextText = String(this.textObject.text || "").slice(0, 200);
        if (this.textObject.text !== nextText) this.textObject.set("text", nextText);
        state.custom_text = nextText;
        const input = document.getElementById("custom-text-input");
        if (input && input.value !== nextText) input.value = nextText;
        updateTextCounter();
        this.markUnsaved();
      });
    }

    markUnsaved() {
      state.hasUnsavedChanges = true;
      state.designComplete = false;
      this.updateFinishAvailability();
    }

    hasMeaningfulDesign() {
      return Boolean(this.artworkObject || state.originalArtwork || String(state.custom_text || "").trim());
    }

    updateFinishAvailability() {
      if (this.finishButton) {
        const unavailable = !this.canvas || !this.hasMeaningfulDesign();
        this.finishButton.disabled = unavailable;
        this.finishButton.setAttribute("aria-disabled", String(unavailable));
      }
      this.updateToolAvailability();
    }

    updateToolAvailability() {
      const unavailable = !this.canvas?.getActiveObject();
      document.querySelectorAll("#cbs-designer-tool [data-cbs-align], #cbs-layer-up, #cbs-layer-down, #cbs-delete-selected").forEach((button) => {
        button.disabled = unavailable;
        button.setAttribute("aria-disabled", String(unavailable));
      });
    }

    getCanvasDimensions() {
      const container = document.getElementById("cbs-designer-canvas-container");
      const size = parseDecalSize();
      const ratio = size.width / size.height;
      const availableWidth = Math.max(1, (container?.clientWidth || 720) * 0.94);
      const availableHeight = Math.max(1, (container?.clientHeight || 420) * 0.9);
      let width = availableWidth;
      let height = width / ratio;
      if (height > availableHeight) { height = availableHeight; width = height * ratio; }
      return { width: Math.max(1, Math.floor(width)), height: Math.max(1, Math.floor(height)) };
    }

    resizeCanvas(preserveObjects = true) {
      if (!this.canvas) return;
      const oldWidth = this.canvas.getWidth() || 1;
      const oldHeight = this.canvas.getHeight() || 1;
      const next = this.getCanvasDimensions();
      if (Math.abs(oldWidth - next.width) < 2 && Math.abs(oldHeight - next.height) < 2) return;
      const editable = this.canvas.getObjects().filter((object) => !object.cbsHelper);
      this.removeHelpers();
      this.canvas.setDimensions(next);
      if (preserveObjects && oldWidth > 1 && oldHeight > 1) {
        const scale = Math.min(next.width / oldWidth, next.height / oldHeight);
        editable.forEach((object) => {
          object.set({ left: (object.left / oldWidth) * next.width, top: (object.top / oldHeight) * next.height, scaleX: object.scaleX * scale, scaleY: object.scaleY * scale });
          object.setCoords();
        });
      }
      this.canvas.calcOffset();
      this.drawGuides();
      this.canvas.requestRenderAll();
    }

    updateBackground(markChanged = true) {
      if (!this.canvas) return;
      this.canvas.setBackgroundColor(backgroundHex(), () => this.canvas.requestRenderAll());
      if (markChanged) this.markUnsaved();
    }

    removeHelpers() {
      [...this.guideObjects, ...this.snapObjects].forEach((object) => this.canvas?.remove(object));
      this.guideObjects = [];
      this.snapObjects = [];
    }

    drawGuides() {
      if (!this.canvas) return;
      this.guideObjects.forEach((object) => this.canvas.remove(object));
      this.guideObjects = [];
      const width = this.canvas.getWidth();
      const height = this.canvas.getHeight();
      const inset = Math.max(10, Math.min(width, height) * 0.07);
      const guideStyle = { selectable: false, evented: false, cbsHelper: true, excludeFromExport: true, opacity: 0.82 };
      const safe = new this.fabric.Rect({ left: inset, top: inset, width: Math.max(1, width - inset * 2), height: Math.max(1, height - inset * 2), fill: "transparent", stroke: "#ff3da7", strokeWidth: 1, strokeDashArray: [7, 5], ...guideStyle });
      const vertical = new this.fabric.Line([width / 2, 0, width / 2, height], { stroke: "#ff3da7", strokeWidth: 1, strokeDashArray: [4, 6], ...guideStyle });
      const horizontal = new this.fabric.Line([0, height / 2, width, height / 2], { stroke: "#ff3da7", strokeWidth: 1, strokeDashArray: [4, 6], ...guideStyle });
      this.guideObjects = [safe, vertical, horizontal];
      this.guideObjects.forEach((object) => this.canvas.add(object));
      this.setGuidesVisible(this.guidesEnabled);
      this.bringHelpersToFront();
    }

    setGuidesVisible(visible) {
      this.guidesEnabled = Boolean(visible);
      state.guidesEnabled = this.guidesEnabled;
      this.guideObjects.forEach((object) => object.set("visible", this.guidesEnabled));
      const toggle = document.getElementById("cbs-toggle-guides");
      if (toggle && toggle.checked !== this.guidesEnabled) toggle.checked = this.guidesEnabled;
      this.canvas?.requestRenderAll();
    }

    setSnappingEnabled(enabled) {
      this.snappingEnabled = Boolean(enabled);
      state.snappingEnabled = this.snappingEnabled;
      const toggle = document.getElementById("cbs-toggle-snapping");
      if (toggle && toggle.checked !== this.snappingEnabled) toggle.checked = this.snappingEnabled;
      if (!this.snappingEnabled) this.clearSnapLines();
    }

    bringHelpersToFront() {
      [...this.guideObjects, ...this.snapObjects].forEach((object) => this.canvas?.bringToFront(object));
    }

    clearSnapLines() {
      this.snapObjects.forEach((object) => this.canvas?.remove(object));
      this.snapObjects = [];
      this.canvas?.requestRenderAll();
    }

    addSnapLine(axis, value) {
      const width = this.canvas.getWidth();
      const height = this.canvas.getHeight();
      const line = axis === "x"
        ? new this.fabric.Line([value, 0, value, height], { stroke: "#f0a028", strokeWidth: 1.5, selectable: false, evented: false, cbsHelper: true, excludeFromExport: true })
        : new this.fabric.Line([0, value, width, value], { stroke: "#f0a028", strokeWidth: 1.5, selectable: false, evented: false, cbsHelper: true, excludeFromExport: true });
      this.canvas.add(line);
      this.snapObjects.push(line);
    }

    snapObject(object) {
      if (!object || !this.snappingEnabled) return;
      this.clearSnapLines();
      const width = this.canvas.getWidth();
      const height = this.canvas.getHeight();
      const center = object.getCenterPoint();
      const halfWidth = object.getScaledWidth() / 2;
      const halfHeight = object.getScaledHeight() / 2;
      const threshold = Math.max(6, Math.min(width, height) * 0.025);
      let x = center.x;
      let y = center.y;
      let snapX = null;
      let snapY = null;
      if (Math.abs(center.x - width / 2) <= threshold) { x = width / 2; snapX = width / 2; }
      else if (Math.abs(center.x - halfWidth) <= threshold) { x = halfWidth; snapX = 0; }
      else if (Math.abs(center.x + halfWidth - width) <= threshold) { x = width - halfWidth; snapX = width; }
      if (Math.abs(center.y - height / 2) <= threshold) { y = height / 2; snapY = height / 2; }
      else if (Math.abs(center.y - halfHeight) <= threshold) { y = halfHeight; snapY = 0; }
      else if (Math.abs(center.y + halfHeight - height) <= threshold) { y = height - halfHeight; snapY = height; }
      object.setPositionByOrigin(new this.fabric.Point(x, y), "center", "center");
      object.setCoords();
      if (snapX !== null) this.addSnapLine("x", snapX);
      if (snapY !== null) this.addSnapLine("y", snapY);
      this.bringHelpersToFront();
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }

    makeArtworkPlaceholder(file) {
      const width = this.canvas.getWidth() * 0.52;
      const height = Math.min(this.canvas.getHeight() * 0.55, 150);
      const box = new this.fabric.Rect({ width, height, rx: 10, ry: 10, fill: "rgba(255,255,255,.94)", stroke: "#111114", strokeWidth: 2, strokeDashArray: [7, 5], originX: "center", originY: "center" });
      const type = getFileExtension(file).toUpperCase() || "ART";
      const label = new this.fabric.Text(`${type} ARTWORK ATTACHED`, { fontFamily: "Arial", fontSize: Math.max(12, Math.min(24, height * 0.16)), fontWeight: "bold", fill: "#111114", originX: "center", originY: "center", textAlign: "center" });
      return new this.fabric.Group([box, label], { originX: "center", originY: "center", left: this.canvas.getWidth() / 2, top: this.canvas.getHeight() / 2, cbsArtwork: true });
    }

    loadFabricImage(src) {
      return new Promise((resolve, reject) => {
        let settled = false;
        this.fabric.Image.fromURL(src, (image) => {
          settled = true;
          if (image?.width && image?.height) resolve(image);
          else reject(new Error("The artwork could not be rendered"));
        }, { crossOrigin: "anonymous" });
        setTimeout(() => { if (!settled) reject(new Error("Artwork preview timed out")); }, 12000);
      });
    }

    async addArtwork(file, preview) {
      if (!this.canvas) throw new Error("The design canvas is not ready.");
      const token = ++this.artworkLoadToken;
      let object;
      if (preview?.src && !preview.placeholder) {
        try {
          object = await this.loadFabricImage(preview.src);
          const scale = Math.min((this.canvas.getWidth() * 0.6) / object.width, (this.canvas.getHeight() * 0.62) / object.height, 1);
          object.set({ scaleX: scale, scaleY: scale, originX: "center", originY: "center", left: this.canvas.getWidth() / 2, top: this.canvas.getHeight() / 2, cbsArtwork: true });
        } catch (error) {
          console.warn("[BumperStickerDesigner] Artwork preview could not be rendered; using an attached-artwork placeholder.", error);
          object = this.makeArtworkPlaceholder(file);
        }
      } else {
        object = this.makeArtworkPlaceholder(file);
      }
      if (token !== this.artworkLoadToken) return;
      if (this.artworkObject) this.canvas.remove(this.artworkObject);
      object.set({ selectable: true, evented: true, hasControls: true, hasBorders: true });
      this.configureUniformTransformControls(object);
      this.canvas.add(object);
      this.canvas.setActiveObject(object);
      this.artworkObject = object;
      state.uploadedImage = file;
      state.originalArtwork = file;
      state.artworkPreview = preview || null;
      this.bringHelpersToFront();
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }
    removeArtwork() {
      this.artworkLoadToken += 1;
      if (this.artworkObject) this.canvas?.remove(this.artworkObject);
      this.artworkObject = null;
      state.uploadedImage = null;
      state.originalArtwork = null;
      state.artworkPreview = null;
      const input = document.getElementById("upload-file");
      if (input) input.value = "";
      setUploadUI(false);
      this.canvas?.discardActiveObject();
      this.canvas?.requestRenderAll();
      this.markUnsaved();
    }
    updateText(text) {
      const nextText = String(text || "").slice(0, 200);
      state.custom_text = nextText;
      if (!this.canvas) { this.updateFinishAvailability(); return; }
      if (!nextText.trim()) {
        if (this.textObject) this.canvas.remove(this.textObject);
        this.textObject = null;
        this.canvas.requestRenderAll();
        this.markUnsaved();
        return;
      }
      if (!this.textObject) {
        const fontSize = Math.max(24, Math.min(64, this.canvas.getHeight() * 0.24));
        this.textObject = new this.fabric.Textbox(nextText, {
          left: this.canvas.getWidth() / 2,
          top: this.canvas.getHeight() / 2,
          width: this.canvas.getWidth() * 0.72,
          originX: "center",
          originY: "center",
          textAlign: "center",
          fontFamily: this.appliedFontFamily || "Arial",
          fontSize,
          lineHeight: 1.05,
          fill: TEXT_COLORS[state.text_color] || "#000000",
          editable: true,
          cbsText: true,
        });
        this.configureUniformTransformControls(this.textObject);
        this.canvas.add(this.textObject);
        void this.updateFont(state.font, { markChanged: false });
      } else {
        this.textObject.set({ text: nextText, width: Math.min(this.textObject.width || this.canvas.getWidth() * 0.72, this.canvas.getWidth() * 0.88) });
      }
      this.configureUniformTransformControls(this.textObject);
      this.canvas.setActiveObject(this.textObject);
      this.bringHelpersToFront();
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }
    async updateFont(font, { markChanged = true, warnUser = false } = {}) {
      state.font = font;
      const applicationToken = ++this.fontApplicationToken;
      const family = await ensureCanvasFont(font, { warnUser });
      if (applicationToken !== this.fontApplicationToken) return family;
      this.appliedFontFamily = family;
      if (!this.textObject) {
        this.updateFinishAvailability();
        return family;
      }
      const center = this.textObject.getCenterPoint();
      const textWidth = this.textObject.width;
      this.textObject.set({ fontFamily: family, width: textWidth });
      this.textObject.initDimensions?.();
      this.textObject.setPositionByOrigin(center, "center", "center");
      this.configureUniformTransformControls(this.textObject);
      this.canvas?.requestRenderAll();
      if (markChanged) this.markUnsaved();
      else this.updateFinishAvailability();
      return family;
    }

    updateTextColor(color) {
      state.text_color = color;
      if (this.textObject) {
        this.textObject.set("fill", TEXT_COLORS[color] || "#000000");
        this.canvas.requestRenderAll();
        this.markUnsaved();
      } else {
        this.updateFinishAvailability();
      }
    }

    alignActive(direction) {
      const active = this.canvas?.getActiveObject();
      if (!active) return showCanvasMessage("Select an artwork or text object first.");
      const width = this.canvas.getWidth();
      const height = this.canvas.getHeight();
      const halfWidth = active.getScaledWidth() / 2;
      const halfHeight = active.getScaledHeight() / 2;
      const center = active.getCenterPoint();
      let x = center.x;
      let y = center.y;
      if (direction === "left") x = halfWidth;
      if (direction === "centerH") x = width / 2;
      if (direction === "right") x = width - halfWidth;
      if (direction === "top") y = halfHeight;
      if (direction === "centerV") y = height / 2;
      if (direction === "bottom") y = height - halfHeight;
      active.setPositionByOrigin(new this.fabric.Point(x, y), "center", "center");
      active.setCoords();
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }

    moveLayer(direction) {
      const active = this.canvas?.getActiveObject();
      if (!active) return showCanvasMessage("Select an artwork or text object first.");
      if (direction === "up") this.canvas.bringForward(active);
      else this.canvas.sendBackwards(active);
      this.bringHelpersToFront();
      this.canvas.setActiveObject(active);
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }

    deleteSelected() {
      const active = this.canvas?.getActiveObject();
      if (!active) return showCanvasMessage("Select an artwork or text object first.");
      if (active === this.artworkObject) return this.removeArtwork();
      if (active === this.textObject) {
        this.canvas.remove(active);
        this.textObject = null;
        state.custom_text = "";
        const input = document.getElementById("custom-text-input");
        if (input) input.value = "";
        updateTextCounter();
      } else { this.canvas.remove(active); }
      this.canvas.discardActiveObject();
      this.canvas.requestRenderAll();
      this.markUnsaved();
    }

    async exportDesign() {
      if (!this.canvas) throw new Error("The design canvas is not ready.");
      if (!this.hasMeaningfulDesign()) throw new Error("Add artwork or custom text before finishing the design.");
      await this.updateFont(state.font, { markChanged: false, warnUser: true });
      if (document.fonts) await document.fonts.ready;
      this.canvas.requestRenderAll();
      await new Promise((resolve) => requestAnimationFrame(resolve));
      this.clearSnapLines();
      this.canvas.discardActiveObject();
      const helperVisibility = this.guideObjects.map((object) => object.visible);
      this.guideObjects.forEach((object) => object.set("visible", false));
      this.canvas.requestRenderAll();
      try {
        const size = parseDecalSize();
        const dpiWidth = Math.max(1, Math.round(size.width * 300));
        const dpiHeight = Math.max(1, Math.round(size.height * 300));
        const capScale = Math.min(1, MAX_EXPORT_DIMENSION / dpiWidth, MAX_EXPORT_DIMENSION / dpiHeight);
        const targetWidth = Math.max(1, Math.round(dpiWidth * capScale));
        const targetHeight = Math.max(1, Math.round(dpiHeight * capScale));
        const multiplier = Math.max(1, Math.min(targetWidth / this.canvas.getWidth(), targetHeight / this.canvas.getHeight()));
        const rawDataURL = this.canvas.toDataURL({ format: "png", multiplier, enableRetinaScaling: false });
        const image = await new Promise((resolve, reject) => {
          const exportImage = new Image();
          exportImage.onload = () => resolve(exportImage);
          exportImage.onerror = () => reject(new Error("The final design could not be rasterized."));
          exportImage.src = rawDataURL;
        });
        const output = document.createElement("canvas");
        output.width = targetWidth;
        output.height = targetHeight;
        const context = output.getContext("2d");
        if (!context) throw new Error("The browser could not create the final design image.");
        const targetRatio = targetWidth / targetHeight;
        const sourceRatio = image.width / image.height;
        let sourceX = 0;
        let sourceY = 0;
        let sourceWidth = image.width;
        let sourceHeight = image.height;
        if (sourceRatio > targetRatio) {
          sourceWidth = image.height * targetRatio;
          sourceX = (image.width - sourceWidth) / 2;
        } else if (sourceRatio < targetRatio) {
          sourceHeight = image.width / targetRatio;
          sourceY = (image.height - sourceHeight) / 2;
        }
        context.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, targetWidth, targetHeight);
        return output.toDataURL("image/png");
      } finally {
        this.guideObjects.forEach((object, index) => object.set("visible", helperVisibility[index]));
        this.bringHelpersToFront();
        this.canvas.requestRenderAll();
      }
    }

    saveCanvasState() {
      if (!this.canvas) return null;
      const json = this.canvas.toJSON(["cbsArtwork", "cbsText", "cbsHelper", "excludeFromExport"]);
      json.objects = (json.objects || []).filter((object) => !object.cbsHelper);
      json.background = backgroundHex();
      state.savedCanvasJSON = json;
      return json;
    }

    async restoreSavedCanvas() {
      if (!this.canvas || !state.savedCanvasJSON) return;
      this.removeHelpers();
      await new Promise((resolve) => this.canvas.loadFromJSON(state.savedCanvasJSON, resolve));
      const editable = this.canvas.getObjects().filter((object) => !object.cbsHelper);
      editable.forEach((object) => this.configureUniformTransformControls(object));
      this.artworkObject = editable.find((object) => object.cbsArtwork) || null;
      this.textObject = editable.find((object) => object.cbsText) || null;
      await this.updateFont(state.font, { markChanged: false, warnUser: true });
      this.drawGuides();
      this.canvas.requestRenderAll();
      this.updateFinishAvailability();
    }

    lockProductScroll() {
      if (document.body.classList.contains("cbs-designer-open")) return;
      lockedScrollY = window.scrollY || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.classList.add("cbs-designer-open");
    }

    restoreProductScroll() {
      document.body.classList.remove("cbs-designer-open");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, lockedScrollY);
    }

    async open() {
      if (!this.designerModal) {
        console.warn("[BumperStickerDesigner] Cannot open because #cbs-designer-tool is missing.");
        return;
      }
      this.designerModal.classList.add("is-open");
      this.designerModal.setAttribute("aria-hidden", "false");
      if (this.loadingElement) this.loadingElement.hidden = false;
      state.designerOpen = true;
      this.lockProductScroll();
      try {
        if (!this.initialized) await this.init();
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (state.savedCanvasJSON && this.canvas && !this.canvas.getObjects().some((object) => !object.cbsHelper)) {
          await this.restoreSavedCanvas();
        }
        this.resizeCanvas(true);
        this.updateBackground(false);
        this.setGuidesVisible(state.guidesEnabled);
        this.setSnappingEnabled(state.snappingEnabled);
        updateDesignSummary();
        this.updateFinishAvailability();
        this.closeButton?.focus();
      } catch (error) {
        console.error("[BumperStickerDesigner] Initialization failed:", error);
        showCanvasMessage("The design canvas could not load. The product options remain available; please retry the designer.");
      } finally {
        if (this.loadingElement) this.loadingElement.hidden = true;
      }
    }

    requestClose() {
      if (!state.hasUnsavedChanges) {
        this.close(true);
        return;
      }
      if (this.closeConfirm) {
        this.closeConfirm.hidden = false;
        document.getElementById("cbs-cancel-close")?.focus();
      } else if (window.confirm("Close without finishing your latest design changes?")) {
        this.close(true);
      }
    }

    close(force = false) {
      if (!force && state.hasUnsavedChanges) {
        this.requestClose();
        return;
      }
      if (this.closeConfirm) this.closeConfirm.hidden = true;
      this.designerModal?.classList.remove("is-open");
      this.designerModal?.setAttribute("aria-hidden", "true");
      state.designerOpen = false;
      this.restoreProductScroll();
      document.getElementById(state.designComplete ? "cbs-edit-design-btn" : "cbs-start-design-btn")?.focus();
    }

    showCompletedPreview() {
      if (this.emptyPreview) this.emptyPreview.hidden = true;
      if (this.completedPreview) this.completedPreview.hidden = false;
      if (this.previewImage) this.previewImage.src = state.finalPreviewDataUrl;
      updateDesignSummary();
    }

    async finishEditing() {
      if (!this.canvas) return showCanvasMessage("The design canvas is still loading.");
      if (!this.hasMeaningfulDesign()) return showCanvasMessage("Add artwork, custom text, or both before finishing.");
      if (this.finishButton) {
        this.finishButton.disabled = true;
        this.finishButton.setAttribute("aria-disabled", "true");
        this.finishButton.setAttribute("aria-busy", "true");
        this.finishButton.classList.add("loading");
        this.finishButton.textContent = "Creating Preview…";
      }
      try {
        state.finalPreviewDataUrl = await this.exportDesign();
        state.editedDesignFile = fileFromDataURL(state.finalPreviewDataUrl, "custom-bumper-sticker-edited-design.png");
        this.saveCanvasState();
        state.designComplete = true;
        state.hasUnsavedChanges = false;
        this.showCompletedPreview();
        const error = document.getElementById("upload-file-error");
        if (error) { error.style.display = "none"; error.textContent = ""; }
        document.getElementById("artwork-variant")?.classList.remove("has-error");
        this.close(true);
      } catch (error) {
        console.error("[BumperStickerDesigner] Export failed:", error);
        showCanvasMessage(error.message || "We could not create the final preview. Please try again.");
      } finally {
        if (this.finishButton) {
          this.finishButton.textContent = "Finish Editing";
          this.finishButton.classList.remove("loading");
          this.finishButton.removeAttribute("aria-busy");
          this.updateFinishAvailability();
        }
      }
    }

    removeDesign() {
      state.uploadedImage = null;
      state.originalArtwork = null;
      state.artworkPreview = null;
      state.finalPreviewDataUrl = "";
      state.editedDesignFile = null;
      state.savedCanvasJSON = null;
      state.designComplete = false;
      state.hasUnsavedChanges = false;
      state.custom_text = "";
      const textInput = document.getElementById("custom-text-input");
      if (textInput) textInput.value = "";
      const fileInput = document.getElementById("upload-file");
      if (fileInput) fileInput.value = "";
      setUploadUI(false);
      updateTextCounter();
      this.reset();
      if (this.emptyPreview) this.emptyPreview.hidden = false;
      if (this.completedPreview) this.completedPreview.hidden = true;
      if (this.previewImage) this.previewImage.removeAttribute("src");
      updateDesignSummary();
      this.updateFinishAvailability();
    }

    reset() {
      this.artworkLoadToken += 1;
      if (!this.canvas) { this.updateFinishAvailability(); return; }
      this.canvas.getObjects().filter((object) => !object.cbsHelper).forEach((object) => this.canvas.remove(object));
      this.artworkObject = null;
      this.textObject = null;
      this.clearSnapLines();
      this.updateBackground(false);
      this.drawGuides();
      this.canvas.discardActiveObject();
      this.canvas.requestRenderAll();
      this.updateFinishAvailability();
    }
  }

  const designer = new BumperStickerDesigner({
    startButtonId: "cbs-start-design-btn",
    editButtonId: "cbs-edit-design-btn",
    modalId: "cbs-designer-tool",
    finishButtonId: "cbs-finish-editing",
    closeButtonId: "cbs-designer-close-btn",
    canvasId: "cbs-sticker-canvas",
    canvasContainerId: "cbs-designer-canvas-container",
    previewImageId: "preview-image",
    emptyPreviewId: "cbs-design-empty",
    completedPreviewId: "cbs-design-complete",
  });
  function setupImageUpload() {
    const input = document.getElementById("upload-file");
    const choose = document.getElementById("cbs-choose-file-btn");
    const remove = document.getElementById("delete-image");
    const zone = document.querySelector("#designer-artwork-variant .cbs-pcs-upload-zone");
    if (!input) {
      warnMissingElement("#upload-file", "artwork upload");
      return;
    }
    if (!choose) warnMissingElement("#cbs-choose-file-btn", "artwork file selection");
    if (!remove) warnMissingElement("#delete-image", "artwork removal");

    choose?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      input.click();
    });

    const processFile = async (file) => {
      if (!isAllowedUpload(file)) {
        showCanvasMessage("Please upload JPG, PNG, WEBP, SVG, PDF, AI, EPS, or TIFF artwork.");
        input.value = "";
        return;
      }
      const previous = {
        uploadedImage: state.uploadedImage,
        originalArtwork: state.originalArtwork,
        artworkPreview: state.artworkPreview,
      };
      try {
        const preview = await buildUploadPreview(file);
        await designer.addArtwork(file, preview);
        setUploadPreview(preview.src, preview.placeholder);
        setUploadUI(true, file.name);
      } catch (error) {
        console.error("[Print Custom Bumper Stickers] Artwork upload failed:", error);
        state.uploadedImage = previous.uploadedImage;
        state.originalArtwork = previous.originalArtwork;
        state.artworkPreview = previous.artworkPreview;
        input.value = "";
        if (previous.originalArtwork) {
          setUploadPreview(previous.artworkPreview?.src || null, Boolean(previous.artworkPreview?.placeholder));
          setUploadUI(true, previous.originalArtwork.name);
        } else {
          setUploadUI(false);
        }
        designer.updateFinishAvailability();
        showCanvasMessage("That artwork could not be added. Your previous design was preserved.");
      }
    };

    input.addEventListener("change", async () => {
      const file = input.files?.[0];
      if (file) await processFile(file);
    });

    if (zone) {
      ["dragenter", "dragover"].forEach((name) => zone.addEventListener(name, (event) => {
        event.preventDefault();
        zone.classList.add("is-dragover");
      }));
      ["dragleave", "drop"].forEach((name) => zone.addEventListener(name, (event) => {
        event.preventDefault();
        zone.classList.remove("is-dragover");
      }));
      zone.addEventListener("drop", async (event) => {
        const file = event.dataTransfer?.files?.[0];
        if (file) await processFile(file);
      });
    }

    remove?.addEventListener("click", (event) => {
      event.preventDefault();
      designer.removeArtwork();
    });
  }
  function updateTextCounter() {
    const input = document.getElementById("custom-text-input");
    const counter = document.getElementById("custom-text-char-count");
    if (!input) warnMissingElement("#custom-text-input", "custom text editing");
    if (!counter) warnMissingElement("#custom-text-char-count", "custom text character counter");
    if (!input || !counter) return;
    counter.textContent = `${Math.max(0, 200 - input.value.length)} character(s) left`;
  }

  function setupCustomText() {
    const input = document.getElementById("custom-text-input");
    if (!input) {
      warnMissingElement("#custom-text-input", "custom text editing");
      return;
    }
    input.maxLength = 200;
    input.addEventListener("input", () => {
      if (input.value.length > 200) input.value = input.value.slice(0, 200);
      state.custom_text = input.value;
      updateTextCounter();
      designer.updateText(input.value);
    });
    updateTextCounter();
  }

  function setupSpecialInstructions() {
    const input = document.getElementById("special-instructions-input");
    const counter = document.getElementById("special-instructions-char-count");
    if (!input) warnMissingElement("#special-instructions-input", "special instructions");
    if (!counter) warnMissingElement("#special-instructions-char-count", "special-instructions counter");
    if (!input || !counter) return;
    const refresh = () => {
      if (input.value.length > 200) input.value = input.value.slice(0, 200);
      state.special_instructions = input.value;
      counter.textContent = `${200 - input.value.length} character(s) left`;
    };
    input.addEventListener("input", refresh);
    refresh();
  }

  function setupTextColorSelection() {
    const list = document.querySelector("#text-color-variant .cbs-letter-color-variants__list");
    const label = document.getElementById("selected-text-color");
    if (!list) { warnMissingElement("#text-color-variant .cbs-letter-color-variants__list", "text-color selection"); return; }
    if (!label) warnMissingElement("#selected-text-color", "selected text-color label");
    list.addEventListener("click", (event) => {
      const swatch = event.target.closest(".sticker-variant");
      if (!swatch) return;
      list.querySelectorAll(".sticker-variant").forEach((item) => item.classList.toggle("active", item === swatch));
      state.text_color = swatch.dataset.color;
      if (label) label.textContent = state.text_color;
      designer.updateTextColor(state.text_color);
      updateDesignSummary();
    });
  }

  function setupDecalSizeSelection() {
    const grid = document.getElementById("decal-size-grid");
    if (!grid) { warnMissingElement("#decal-size-grid", "decal-size selection"); return; }
    grid.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected) return;
      event.preventDefault();
      grid.querySelectorAll(".sticker-variant").forEach((item) => item.classList.toggle("active", item === selected));
      state.decal_size = selected.dataset.decalSize;
      syncBackgroundToSize();
      designer.resizeCanvas(true);
      designer.markUnsaved();
      document.getElementById("decal-size-error-bar")?.style.setProperty("display", "none");
      updateDesignSummary();
      recalcPrice();
    });
  }

  function setupQuantitySelection() {
    const grid = document.getElementById("quantity-grid");
    if (!grid) { warnMissingElement("#quantity-grid", "quantity selection"); return; }
    grid.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected) return;
      event.preventDefault();
      grid.querySelectorAll(".sticker-variant").forEach((item) => item.classList.toggle("active", item === selected));
      state.quantity = Number(selected.dataset.quantity);
      document.getElementById("quantity-error-bar")?.style.setProperty("display", "none");
      recalcPrice();
    });
  }

  function setupLaminationSelection() {
    const wrapper = document.getElementById("lamination-variant");
    if (!wrapper) { warnMissingElement("#lamination-variant", "lamination selection"); return; }
    const rows = wrapper.querySelectorAll(".cbs-pcs-addon-row");
    rows.forEach((row) => row.addEventListener("click", (event) => {
      event.preventDefault();
      rows.forEach((item) => item.classList.toggle("active", item === row));
      wrapper.querySelector('[data-lamination="No Lamination"].cbs-pcs-lamination-sync')?.classList.toggle("active", row.dataset.lamination === "No Lamination");
      state.lamination = row.dataset.lamination;
      recalcPrice();
    }));
    wrapper.querySelector('.cbs-pcs-addon-row[data-lamination="No Lamination"]')?.classList.add("active");
  }

  function validateForm() {
    let firstInvalid = null;
    const hasArtwork = Boolean(state.uploadedImage || designer.artworkObject);
    const hasText = Boolean(String(state.custom_text || "").trim());
    const hasMeaningfulDesign = hasArtwork || hasText;
    const designValid = Boolean(
      hasMeaningfulDesign &&
      state.designComplete &&
      state.editedDesignFile &&
      !state.hasUnsavedChanges
    );
    const designError = document.getElementById("upload-file-error");
    if (!designError) warnMissingElement("#upload-file-error", "design validation feedback");
    if (designError) {
      designError.textContent = hasMeaningfulDesign
        ? (state.hasUnsavedChanges ? "Please finish your latest design changes before adding to cart." : "Please finish your bumper sticker design before adding to cart.")
        : "Add artwork, custom text, or both, then finish your bumper sticker design.";
      designError.style.display = designValid ? "none" : "block";
    }
    document.getElementById("artwork-variant")?.classList.toggle("has-error", !designValid);
    if (!designValid) firstInvalid = document.getElementById("artwork-variant");

    const sizeValid = Boolean(state.decal_size && parseDecalSize(state.decal_size).width);
    const sizeError = document.getElementById("decal-size-error-bar");
    if (sizeError) sizeError.style.display = sizeValid ? "none" : "block";
    if (!sizeValid && !firstInvalid) firstInvalid = document.getElementById("decal-size-variant");

    const quantityValid = Number.isFinite(Number(state.quantity)) && Number(state.quantity) > 0;
    const quantityError = document.getElementById("quantity-error-bar");
    if (quantityError) quantityError.style.display = quantityValid ? "none" : "block";
    if (!quantityValid && !firstInvalid) firstInvalid = document.getElementById("quantity-variant");

    const selectionsValid = Boolean(
      state.background_color &&
      state.font &&
      state.text_color &&
      state.lamination
    );
    if (!selectionsValid && !firstInvalid) firstInvalid = document.getElementById("cbs-designer-tool") || document.getElementById("artwork-variant");

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }
  function resetCalculatorForm() {
    designer.removeDesign();
    state.background_color = "Black Rectangle";
    state.font = "Anton";
    state.text_color = "Black";
    state.decal_size = "2.5x8.3 - Rectangle";
    state.quantity = 1;
    state.lamination = "No Lamination";
    state.special_instructions = "";
    state.price = BASE_PRICE;
    state.guidesEnabled = true;
    state.snappingEnabled = true;
    state.hasUnsavedChanges = false;
    state.designComplete = false;
    state.savedCanvasJSON = null;

    setDropdownValue(document.getElementById("background-color-select"), state.background_color);
    setDropdownValue(document.getElementById("font-select"), state.font);
    document.querySelectorAll("#decal-size-grid .sticker-variant").forEach((button) => button.classList.toggle("active", button.dataset.decalSize === state.decal_size));
    document.querySelectorAll("#quantity-grid .sticker-variant").forEach((button) => button.classList.toggle("active", button.dataset.quantity === "1"));
    document.querySelectorAll("#text-color-variant .sticker-variant").forEach((button) => button.classList.toggle("active", button.dataset.color === "Black"));
    const colorLabel = document.getElementById("selected-text-color");
    if (colorLabel) colorLabel.textContent = "Black";
    document.querySelectorAll("#lamination-variant .cbs-pcs-addon-row").forEach((button) => button.classList.toggle("active", button.dataset.lamination === "No Lamination"));
    document.querySelector('#lamination-variant .cbs-pcs-lamination-sync[data-lamination="No Lamination"]')?.classList.add("active");
    const instructions = document.getElementById("special-instructions-input");
    if (instructions) instructions.value = "";
    const instructionsCounter = document.getElementById("special-instructions-char-count");
    if (instructionsCounter) instructionsCounter.textContent = "200 character(s) left";
    document.querySelectorAll(".cbs-error-bar, #upload-file-error").forEach((error) => { error.style.display = "none"; });
    document.querySelectorAll(".cbs-pcs-variant").forEach((section) => section.classList.remove("has-error"));
    const guidesToggle = document.getElementById("cbs-toggle-guides");
    const snappingToggle = document.getElementById("cbs-toggle-snapping");
    if (guidesToggle) guidesToggle.checked = true;
    if (snappingToggle) snappingToggle.checked = true;
    designer.setGuidesVisible(true);
    designer.setSnappingEnabled(true);
    designer.resizeCanvas(true);
    designer.updateBackground(false);
    designer.updateFinishAvailability();
    updateDesignSummary();
    recalcPrice();
  }
  async function parseJsonResponse(response, label) {
    const body = await response.text();
    if (!body) return null;
    try { return JSON.parse(body); }
    catch (error) { throw new Error(`${label} returned invalid JSON (HTTP ${response.status}).`); }
  }

  function responseErrorMessage(payload) {
    if (!payload) return "";
    if (typeof payload === "string") return payload;
    return payload.message || payload.description || payload.error || payload.errors || "";
  }
  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("cbs-pcs-add-to-cart");
    if (!addToCartBtn) { warnMissingElement("#cbs-pcs-add-to-cart", "Add to Cart"); return; }
    if (addToCartBtn.dataset.bound) return;
    addToCartBtn.dataset.bound = "true";

    addToCartBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      if (!validateForm()) return;

      addToCartBtn.classList.remove("shine");
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = CBS_PCS_CART_LOADING_HTML;

      const actualQuantity = state.quantity === 1 ? "One Sticker" : `${state.quantity} of the same Sticker`;
      const checkoutArtwork = state.originalArtwork;

      try {
        const requestData = {
          calculatorId: "8cfd78d7019c4",
          productId: 7695191638064,
          properties: {
            "Background Color": state.background_color,
            "Text Font": state.font,
            "Text Color": state.text_color,
            "Custom Text": state.custom_text,
            "Decal Size": state.decal_size,
            "Special Instructions": state.special_instructions,
            Quantity: actualQuantity,
            Lamination: state.lamination === "YES ADD LAM- Recommend if used on cars" ? "Yes" : "No",
            "Upload Image": checkoutArtwork?.name || "",
          },
        };

        const variantRes = await fetch("https://api.custompricecalculator.com/api/v1/variant", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });
        const variantPayload = await parseJsonResponse(variantRes, "Apippa variant service");
        if (!variantRes.ok) {
          const detail = responseErrorMessage(variantPayload) || variantRes.statusText || `HTTP ${variantRes.status}`;
          throw new Error(`Apippa variant request failed: ${detail}`);
        }
        const shopifyVariantId = typeof variantPayload === "string" || typeof variantPayload === "number"
          ? variantPayload
          : (variantPayload?.variantId || variantPayload?.id);
        if (!shopifyVariantId || !/^\d+$/.test(String(shopifyVariantId))) {
          throw new Error("Apippa returned an invalid Shopify variant ID.");
        }

        const formData = new FormData();
        formData.append("id", String(shopifyVariantId));
        formData.append("quantity", "1");
        Object.entries(requestData.properties).forEach(([key, value]) => {
          if (key === "Upload Image" && checkoutArtwork) return;
          formData.append(`properties[${key}]`, String(value ?? ""));
        });
        if (checkoutArtwork) formData.append("properties[Upload Image]", checkoutArtwork, checkoutArtwork.name);
        if (state.editedDesignFile) formData.append("properties[Edited Design]", state.editedDesignFile, state.editedDesignFile.name);

        const cartAddRes = await fetch("/cart/add.js", { method: "POST", body: formData });
        const cartAddJson = await parseJsonResponse(cartAddRes, "Shopify cart");
        if (!cartAddRes.ok) {
          const detail = responseErrorMessage(cartAddJson) || cartAddRes.statusText || `HTTP ${cartAddRes.status}`;
          throw new Error(`Shopify could not add this design: ${detail}`);
        }
        if (!cartAddJson?.id) throw new Error("Shopify returned an incomplete cart item response.");

        localStorage.setItem(`patched-cart-item-${cartAddJson.id}`, JSON.stringify({ id: cartAddJson.id, title: cartAddJson.product_title, image: cartAddJson.image, price: cartAddJson.price }));
        const cartJson = {
          items: [cartAddJson], item_count: 1, total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price, total_discount: 0,
        };

        const timestamp = Date.now();
        const cartDrawer = document.querySelector("cart-drawer");
        const stickyBuybar = document.getElementById("cbs-pcs-buybar-sticky");
        if (stickyBuybar) stickyBuybar.classList.add("is-cart-open");
        await new Promise((resolve) => setTimeout(resolve, 200));
        try {
          const sectionResponse = await fetch(`/cart?section_id=mini-cart&t=${timestamp}`);
          if (!sectionResponse.ok) throw new Error(`HTTP ${sectionResponse.status}`);
          const sectionHtml = await sectionResponse.text();
          const fakeDiv = document.createElement("div");
          fakeDiv.innerHTML = sectionHtml;
          const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
          if (cartDrawer && miniCartHTML) {
            cartDrawer.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: { cart: { ...cartJson, sections: { "mini-cart": miniCartHTML } }, openMiniCart: true },
            }));
          }
        } catch (error) {
          console.warn("Mini-cart refresh failed after the item was added:", error);
        }

        setTimeout(() => {
          const lineItems = cartDrawer?.querySelectorAll("line-item") || [];
          lineItems.forEach((lineItem) => {
            const desktopPrice = lineItem.querySelector(".line-item__price-list-container .price");
            const mobilePrice = lineItem.querySelector(".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price");
            const priceNode = desktopPrice || mobilePrice;
            if (!priceNode || !/Free|\$0\.00/.test(priceNode.textContent.trim())) return;
            let variantFromDom;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) variantFromDom = productLink.href.split("variant=")[1].split("&")[0];
            if (!variantFromDom) {
              const removeHref = lineItem.querySelector("a[href*='/cart/change?id=']")?.getAttribute("href") || "";
              variantFromDom = removeHref.match(/id=(\d+):/)?.[1];
            }
            if (String(variantFromDom) === String(shopifyVariantId)) {
              const html = `<span class="visually-hidden">Sale price</span>$${(cartAddJson.price / 100).toFixed(2)}`;
              if (desktopPrice) desktopPrice.innerHTML = html;
              if (mobilePrice) mobilePrice.innerHTML = html;
            }
          });
        }, 300);

        setTimeout(async () => {
          try {
            const cartData = await fetch("/cart.js").then((response) => response.json());
            const count = document.querySelector("cart-count");
            if (count) count.textContent = cartData.item_count;
          } catch (error) { console.warn("Cart count refresh failed:", error); }
        }, 300);

        setTimeout(async () => {
          const drawerContent = document.querySelector("#shopify-section-mini-cart .drawer__content");
          if (!drawerContent) return;
          if (!customElements.get("dotlottie-player")) {
            await new Promise((resolve) => {
              const script = document.createElement("script");
              script.src = "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js";
              script.onload = resolve;
              script.onerror = resolve;
              document.head.appendChild(script);
            });
          }
          if (!customElements.get("dotlottie-player")) return;
          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src = "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width:300px;height:300px");
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => confetti.remove(), 3000);
        }, 1000);

        resetCalculatorForm();
      } catch (error) {
        console.error("Apippa Add to Cart Error:", error);
        alert(error.message || "There was a problem adding your item to the cart. Your design has been preserved so you can retry.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = CBS_PCS_CART_BTN_HTML;
      }
    });
  }

  function playCartButtonShine() {
    const button = document.getElementById("cbs-pcs-add-to-cart");
    if (!button || button.classList.contains("loading")) return;
    button.classList.remove("shine");
    void button.offsetWidth;
    button.classList.add("shine");
  }

  function setupCartButtonShine() {
    const button = document.getElementById("cbs-pcs-add-to-cart");
    if (!button || button.dataset.shineBound) return;
    button.dataset.shineBound = "true";
    setTimeout(playCartButtonShine, 1500);
    setInterval(playCartButtonShine, 5000);
  }

  function setupMobileStickyBuybar() {
    const sticky = document.getElementById("cbs-pcs-buybar-sticky");
    const trigger = document.getElementById("cbs-pcs-buybar-sticky-trigger");
    const spacer = document.getElementById("cbs-pcs-buybar-sticky-spacer");
    if (!sticky || !trigger || !spacer) return;
    const mobile = window.matchMedia("(max-width: 768px)");

    const reset = () => {
      sticky.classList.remove("is-stuck");
      spacer.style.height = "0";
    };
    const update = () => {
      if (!mobile.matches || document.body.classList.contains("cbs-designer-open")) return reset();
      const viewportHeight = window.visualViewport?.height || window.innerHeight || 0;
      const stuck = trigger.getBoundingClientRect().top <= Math.max(0, viewportHeight - 1);
      sticky.classList.toggle("is-stuck", stuck);
      spacer.style.height = stuck ? `${sticky.offsetHeight}px` : "0";
    };
    mobile.addEventListener("change", update);
    window.addEventListener("resize", update);
    (document.scrollingElement || document.documentElement).addEventListener("scroll", update, { passive: true });
    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);
    update();

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      const sync = () => sticky.classList.toggle("is-cart-open", cartDrawer.hasAttribute("open"));
      new MutationObserver(sync).observe(cartDrawer, { attributes: true, attributeFilter: ["open"] });
      sync();
    }
  }

  async function initialize() {
    initDropdownDefaults();
    try {
      await designer.init();
    } catch (error) {
      console.error("[Print Custom Bumper Stickers] Designer initialization failed; the ordinary product form remains available:", error);
    }

    setupImageUpload();
    setupTextColorSelection();
    setupDecalSizeSelection();
    setupQuantitySelection();
    setupLaminationSelection();
    setupCustomText();
    setupSpecialInstructions();
    setupApippaAddToCart();
    setupCartButtonShine();
    setupMobileStickyBuybar();
    document.addEventListener("click", dropdownClickHandler);
    updateDesignSummary();
    recalcPrice();
  }

  initialize().catch((error) => console.error("[Print Custom Bumper Stickers] Product initialization failed:", error));
});